/**
 * ADOBE CONFIDENTIAL
 * __________________
 * Copyright 2023 Adobe
 * All Rights Reserved.
 * __________________
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 */

import { HTMLAttributes } from 'preact/compat';
import '@/pdp/components/PriceRange/PriceRange.css';
import { FunctionalComponent } from 'preact';
import { Price } from '@adobe-commerce/elsie/components';

export interface PriceRangeProps extends HTMLAttributes<HTMLDivElement> {
  locale?: string;
  variant?: 'default' | 'strikethrough';
  currency?: string;

  // Simple product
  amount?: number;
  sale?: boolean;

  // Complex product (range)
  minimumAmount?: number;
  maximumAmount?: number;
}

export const PriceRange: FunctionalComponent<PriceRangeProps> = ({
  amount,
  currency,
  locale,
  variant,
  sale,
  minimumAmount,
  maximumAmount,
  className,
  ...props
}) => {
  return (
    <>
      {amount || minimumAmount === maximumAmount ? (
        <div className={'pdp-price-range'} {...props}>
          <Price
            amount={amount ? amount : minimumAmount}
            currency={currency}
            locale={locale}
            variant={variant}
            sale={sale}
            className={className}
          />
        </div>
      ) : (
        <div className={'pdp-price-range'} {...props}>
          <Price
            amount={minimumAmount}
            currency={currency}
            locale={locale}
            className={className}
          />
          <span className="pdp-price-range__label">{'-'}</span>
          <Price
            amount={maximumAmount}
            currency={currency}
            locale={locale}
            className={className}
          />
        </div>
      )}
    </>
  );
};
